import { ReactNode } from 'react'
import { Grid, GridProps } from '@mui/material'

type GridContainerProps = {
  children: ReactNode
  marginY?: boolean
  justifyCenter?: boolean
  spacing?: number | string
  rowSpacing?: string | number
}

export function GridContainer({
  children,
  marginY,
  spacing,
  justifyCenter,
  rowSpacing,
  ...rest
}: GridContainerProps & GridProps) {
  return (
    <Grid
      container
      rowSpacing={rowSpacing || 2}
      columnSpacing={spacing || { lg: 2, md: 2 }}
      direction="row"
      justifyContent={justifyCenter ? 'center' : 'flex-start'}
      marginY={marginY ? 1 : 'none'}
      {...rest}
    >
      {children}
    </Grid>
  )
}

type GridItemProps = {
  children?: ReactNode
  xs?: number
  sm?: number
  md?: number
  lg?: number
  xl?: number
}

export function GridItem({ children, sm, xs, md, lg, xl }: GridItemProps) {
  return (
    <Grid item xs={xs || 12} sm={sm || 12} md={md} lg={lg} xl={xl}>
      {children}
    </Grid>
  )
}
